import './publicPath'

const Vue = window.Vue
Vue.component('offersbutton', () => import('./OffersButton.vue'))
Vue.component('offersmyaccount', () => import('./OffersMyAccount.vue'))
Vue.component('offerswrapper', () => import('./OffersWrapper.vue'))
